<template>
	<div class="box">
		<div class="container" ref="container">

			<div class="map-content">
				<canvas class="canvas" ref="canvas" width="1280" height="720"></canvas>
				<div class="hover-box" v-if="xs&&item">
					<div class="left-box"  v-if="xs">
						<div>{{item.city}}</div>
						<div>
							<div v-if="item.production_base" :style="{
					backgroundColor: list.production_base_color
				}"></div>
							<div v-if="item.rd_center" :style="{
					backgroundColor: list.rd_center_color
				}"></div>
						</div>
					</div>
					<!-- :style="{
						width:xsOne?'100%':'0'
					}" -->
					<div class="xian"  :style="{
						width:xsOneWidth
					}"></div>
					<!-- :style="{
						opacity:xsTwo?'1':'0'
					}" -->
					<div class="right-box"  :style="{
						opacity:xsTwoWidth
					}">
						<div v-if="item.production_base">{{item.production_base}}</div>
						<div v-if="item.rd_center">{{item.rd_center}}</div>
					</div>
				</div>
			</div>
			<div class="left">
				<div class="list">
					<div :class="{ item: true, active: i === index }" v-for="(v, i) in list.tableData" :index="i"
						@click="goQh(v,i)">
						<span>
							{{v.city}}
						</span>
					</div>
				</div>
				<div class="list_sekuai">
					<div>
						<div :style="{
					backgroundColor: list.rd_center_color
				}"></div>
						<div>{{$t('i18n_20')}}</div>
					</div>
					<div>
						<div :style="{
					backgroundColor: list.production_base_color
				}"></div>
						<div>{{$t('i18n_21')}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as d3 from 'd3';
	import * as topojson from 'topojson';
	import jsonData from '@/assets/countries-110m.json';
	class Versor {
		static fromAngles([l, p, g]) {
			l *= Math.PI / 360;
			p *= Math.PI / 360;
			g *= Math.PI / 360;
			const sl = Math.sin(l),
				cl = Math.cos(l);
			const sp = Math.sin(p),
				cp = Math.cos(p);
			const sg = Math.sin(g),
				cg = Math.cos(g);
			return [
				cl * cp * cg + sl * sp * sg,
				sl * cp * cg - cl * sp * sg,
				cl * sp * cg + sl * cp * sg,
				cl * cp * sg - sl * sp * cg
			];
		}
		static toAngles([a, b, c, d]) {
			return [
				Math.atan2(2 * (a * b + c * d), 1 - 2 * (b * b + c * c)) * 180 / Math.PI,
				Math.asin(Math.max(-1, Math.min(1, 2 * (a * c - d * b)))) * 180 / Math.PI,
				Math.atan2(2 * (a * d + b * c), 1 - 2 * (c * c + d * d)) * 180 / Math.PI
			];
		}
		static interpolateAngles(a, b) {
			const i = Versor.interpolate(Versor.fromAngles(a), Versor.fromAngles(b));
			return t => Versor.toAngles(i(t));
		}
		static interpolateLinear([a1, b1, c1, d1], [a2, b2, c2, d2]) {
			a2 -= a1, b2 -= b1, c2 -= c1, d2 -= d1;
			const x = new Array(4);
			return t => {
				const l = Math.hypot(x[0] = a1 + a2 * t, x[1] = b1 + b2 * t, x[2] = c1 + c2 * t, x[3] = d1 + d2 *
					t);
				x[0] /= l, x[1] /= l, x[2] /= l, x[3] /= l;
				return x;
			};
		}
		static interpolate([a1, b1, c1, d1], [a2, b2, c2, d2]) {
			let dot = a1 * a2 + b1 * b2 + c1 * c2 + d1 * d2;
			if (dot < 0) a2 = -a2, b2 = -b2, c2 = -c2, d2 = -d2, dot = -dot;
			if (dot > 0.9995) return Versor.interpolateLinear([a1, b1, c1, d1], [a2, b2, c2, d2]);
			const theta0 = Math.acos(Math.max(-1, Math.min(1, dot)));
			const x = new Array(4);
			const l = Math.hypot(a2 -= a1 * dot, b2 -= b1 * dot, c2 -= c1 * dot, d2 -= d1 * dot);
			a2 /= l, b2 /= l, c2 /= l, d2 /= l;
			return t => {
				const theta = theta0 * t;
				const s = Math.sin(theta);
				const c = Math.cos(theta);
				x[0] = a1 * c + a2 * s;
				x[1] = b1 * c + b2 * s;
				x[2] = c1 * c + c2 * s;
				x[3] = d1 * c + d2 * s;
				return x;
			};
		}
	}
	const world = jsonData
	const land = topojson.feature(world, world.objects.land)
	const borders = topojson.mesh(world, world.objects.countries, (a, b) => a !== b)
	const countries = topojson.feature(world, world.objects.countries).features
	// const land = window.land
	// const borders = window.borders
	// const countries = window.countries
	let canvas
	let context
	let width
	let height
	let projection
	let path
	let p1, p2 = [0, 0],
		r1, r2 = [0, 0, 0];

	export default {
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				index: 0,
				item: '',
				xs: true,
				xsOne: true,
				xsTwo: true,
				xsOneWidth:"",
				xsTwoWidth:"",
				aaInter: '',
				// list: [
				//   // {country:"China" ,id:"156", locationid: "中国&#183;上海" },
				//   // {country:"China" , id:"156",locationid: "中国&#183;常州"},
				//   // {country:"China" , id:"156",locationid: "中国&#183;武汉"},
				//   // {country:"Japan" , id:"392", locationid: "日本&#183;东京"},
				//   // {country:"Korea, Republic of" , id: "410", locationid: "韩国&#183;首尔"},
				//   // {country:"Malaysia" ,id: "458", locationid: "马来西亚&#183;吉隆坡"},
				//   // {country:"Australia" , id:"36",locationid: "澳大利亚&#183;墨尔本"},
				//   // {country:"United States" ,  id: "840",locationid: "美国&#183;休斯顿"},
				//   // {country:"Poland" , id:"616",locationid: "波兰&#183;华沙"},
				//   // {country:"Morocco" , id:"504",locationid: "摩洛哥&#183;卡萨布兰卡"},
				//   // {country:"South Africa" , id:"710", locationid: "南非&#183;约翰内斯堡"},
				// ],

			};
		},
		mounted() {
			this.init();

			//  let index = this.index; // 动画结束， 下标才是正确的
			//  setInterval(() => {
			//    if(index >= this.list.length) index = 0;
			//    let find = countries.find(v =>  {
			//      if (Object.hasOwnProperty.call(v, 'id')) 
			// if(v.properties.name=='Russia'){
			// 	console.log(v,"根据国家名字找id")
			// 	return v
			// }
			//         // return v.id === this.list[index].id 
			//      return false
			//    })
			//    console.log(this.list[index], 'find', find)
			// console.log(d3.geoCentroid(find),"经纬度")
			//    if (find) this.animal([64.647499,34.379197], () => {
			//        // 显示图标
			//    })
			//    this.index = index;
			//    index+=1;
			//  }, 3000)
		},
		watch: {
			'list.tableData'() {
				let t = this;
				this.xs = false;
				this.xsOne = false;
				this.xsTwo = false;
				this.item = '';
				let loc = this.list.tableData[0].location.split(',');
				loc.map(v => {
					v = Number(v);
					return v
				});
				this.$nextTick(function() {
					this.animal(loc, () => {
						t.xs = true;
						setTimeout(function(){
							t.xsOne = true;
							setTimeout(function(){
								t.xsTwo = true;
							},300)
						},300)
						// 显示图标
						t.item = t.list.tableData[0]
					})
					clearInterval(this.aaInter)
					this.aaInter = setInterval(() => {
						t.index++;
						let index = this.index;
						if (index >= t.list.tableData.length) {
							t.index = 0
						};
						t.xs = false;
						t.xsOne = false;
						t.xsTwo = false;
						t.goXz(t.list.tableData[t.index], t.index);
					}, 5000)
				})

			},
			xs(){
				if(this.xs==false){
					this.xsOne=false;
					this.xsTwo=false;
					this.$forceUpdate();
				}
				// console.log(this.xs,"发生了改变xs")
			},
			xsOne(){
				this.xsOneWidth= this.xsOne?'100%':'0px'
				this.$forceUpdate();
			},
			xsTwo(){
				this.xsTwoWidth=this.xsTwo?'1':'0'
				this.$forceUpdate();
			}
		},
		// computed:{
		// 	xsOneWidth(){
		// 		console.log(this.xsOne,"发生了改变xsOne")
		// 		return {
		// 			'width':this.xsOne?'100%':'0px'
		// 		}
		// 	},
		// 	xsTwoWidth(){
		// 		console.log(this.xsTwo,"发生了改变xsTwo")
		// 		return {
		// 			'opacity':this.xsTwo?'1':'0'
		// 		}
		// 	}
		// },
		methods: {
			init() {
				width =820;
				height = 720;
				canvas = this.$refs.canvas
				context = canvas.getContext("2d");
				// canvas.width = width;
				// canvas.height = height;
				canvas.width = 1280;
				canvas.height = 720;
				projection = d3.geoOrthographic().fitExtent([
					[10, 10],
					[width - 10, height - 10]
				], {
					type: "Sphere"
				});
				path = d3.geoPath(projection, context);
				this.render();
			},
			animal(point, callback) {
				// console.log(point, 'point')
				p1 = p2, p2 = point;
				r1 = r2, r2 = [-p2[0], -p2[1], 0];
				const ip = d3.geoInterpolate(p1, p2);
				const iv = Versor.interpolateAngles(r1, r2);

				d3.transition()
					.duration(800)
					.tween("render", () => t => {
						projection.rotate(iv(t));
						this.render({
							type: "Point",
							coordinates: ip(t)
						});
					})
					.transition()
					.tween("render", () => t => {
						this.render({
							type: "Point",
							coordinates: p2
						});
						context.beginPath(), path({
							type: "Point",
							coordinates: p2
						}), context.strokeStyle = "#000", context.stroke();
						callback && callback()
					})
					.end();
			},
			render(arc) {
				const offsetY = height / 2;
				const offsetX = width / 2;
				const temp = Math.min(width, height);
				const radius1 = temp / 6;
				const radius2 = temp / 2.6;
				const radius3 = temp / 1.8;
				// 清空画布
				context.clearRect(0, 0, width, height);
				// 全局颜色
				context.fillStyle = "#fff", context.beginPath(), path({
					type: "Sphere"
				}), context.fill();
				// 渲染国家颜色 颜色
				context.beginPath(), path(land), context.fillStyle = "#eee", context.fill();
				// 渲染线
				// context.beginPath(), path(borders), context.strokeStyle = "#fff", context.lineWidth = 0.5, context.stroke();
				// 黑边
				// context.beginPath(), path({ type: "Sphere" }), context.strokeStyle = "#000", context.lineWidth = 1.5, context.stroke();
				// 环形线
				context.beginPath(), context.arc(offsetX, offsetY, radius1, 0, 2 * Math.PI), context.strokeStyle = "#fff",
					context.lineWidth = 2, context.stroke();
				context.beginPath(), context.arc(offsetX, offsetY, radius2, 0, 2 * Math.PI), context.strokeStyle = "#fff",
					context.lineWidth = 2, context.stroke();
				context.beginPath(), context.arc(offsetX, offsetY, radius3, 0, 2 * Math.PI), context.strokeStyle = "#fff",
					context.lineWidth = 2, context.stroke();
			},
			goXz(item, index) {
				let t = this;
				t.xs = false;
				t.xsOne = false;
				t.xsTwo = false;
				t.item = '';
				this.index = index;
				let loc = '';
				if (item.location) {
					loc = item.location.split(',');
					loc.map(v => {
						v = Number(v);
						return v
					});
				}
				this.$nextTick(function() {
					if (loc) {
						this.animal(loc, () => {
							// 显示图标
							t.item = item;
							if (!t.xs) {
								t.xs = true;
								setTimeout(function(){
									t.xsOne = true;
									setTimeout(function(){
										t.xsTwo = true;
									},300)
								},300)
							}
						})
					}
					// else{
					//  t.item=item
					//  t.xs=true;
					// }
					t.$forceUpdate()
				})

			},
			goQh(item, index) {
				let t = this;
				t.xs = false;
				t.xsOne = false;
				t.xsTwo = false;
				if(this.aaInter){
					clearInterval(this.aaInter)
				}
				t.goXz(item, index);
				this.aaInter = setInterval(() => {
					t.index++;
					let index = this.index;
					if (index >= t.list.tableData.length) {
						t.index = 0
					};
					t.xs = false;
					t.xsOne = false;
					t.xsTwo = false;
					t.goXz(t.list.tableData[t.index], t.index);
				}, 5000)
			}
		},
	};
</script>

<style>
	.box {
		width: 100%;
		height: 720px;
		box-sizing: border-box;
	}

	.container {
		height: 100%;
		/* background-color: #ccc; */
		display: flex;
		justify-content: space-between;
		overflow: hidden;

	}

	.list .item {
		font-size: 20px;
		color: #666;
		padding: 5px;
		cursor: pointer;
	}

	.list .item.active {
		color: #000;
	}


	.canvas {
		height: 130%;
	}

	.map-content {
		width: 820px;
		position: relative;
		top: 0;
	}
</style>
<style scoped lang="scss">
	.left {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		flex-direction: column;
		position: relative;
		z-index: 99;
		.list_sekuai {
			padding-bottom: 30px;

			>div:nth-of-type(1) {
				margin-bottom: 12px;
			}

			>div {
				display: flex;

				>div:nth-of-type(1) {
					width: 12px;
					height: 12px;
					margin-right: 12px;
				}

				>div:nth-of-type(2) {
					font-size: 12px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #777777;
				}
			}
		}
	}

	.hover-box-two {
		width: 100% !important;
	}

	.hover-box-three {
		width: 0% !important;
	}

	.hover-box {
		position: absolute;
		width: 80%;
		// height: 2px;
		top: 65%;
		left: 65%;
		// background-color: #000;

		.xian {
			position: absolute;
			left: 0%;
			width: 0;
			height: 2px;
			background-color: #000;
			transition: all .3s ease;
			// width:0;
			// border-top:1px solid #000;
			// -webkit-transition:width linear 1s;
			// transition:width linear 1s
		}

		.right-box {
			transition: all 1s ease;
			position: absolute;
			// width: 20px;
			// height: 40px;
			right: 0%;
			opacity: 0;
			/* background-color: red; */
			>div {
				padding-top: 20px;
				text-align: right;
			}
		}

		.left-box {
			transition: all .3s ease;
			position: absolute;
			// width: 120px;
			// height: 40px;
			left: 0%;

			>div:nth-of-type(1) {
				padding: 3px 10px;
				background: #000;
				border: 1px solid #000;
				color: #fff;
				text-align: center;

			}

			>div:nth-of-type(2) {
				width: 100%;
				display: flex;

				>div {
					flex: 1;
					height: 5px;
				}
			}

			/* background-color: red; */
		}
	}
</style>